import { CreatorsToActions } from '../helper'

type Actions = CreatorsToActions<typeof import('../actions/loading')>

interface State {
  loading: boolean
}
// ______________________________________________________
//
export function initialState(injects?: State): State {
  return {
    loading: false
  }
}
// ______________________________________________________
//
export function reducer(state = initialState(), action: Actions): State {
  switch (action.type) {
    case 'SET_LOADING':
      return {
        ...state,
        loading: true
      }
    case 'UNSET_LOADING':
      return { ...state, loading: false }
    default:
      return state
  }
}
